const is_function = func => func && typeof func === 'function';

export {is_function};
